import clsx from 'clsx'
import type { ReactNode } from 'react'

import { Typography, type TTypographyProps } from '@/src/elements/text/Typography'

export const ArticleSubtitle = ({ className, ...otherProps }: TTypographyProps): ReactNode => (
  <Typography
    colors="secondary"
    contrast="high"
    size="xl"
    heading="h2"
    className={clsx('mb-2 mt-6 font-black', className)}
    {...otherProps}
  />
)
